import { useRecoilValue } from "recoil";
import { SecretNetworkClient } from "secretjs";

import { useConfig } from "./useConfig";
import { defaultGas, sleepTime } from "../utils/constants";
import { walletState } from "../context/walletState";
import { coinConvert, sleep } from "../utils/common";
import { queryClientState } from "../context/queryClientState";

export const useNativeToken = () => {
  const { queryClient } = useRecoilValue(queryClientState);
  const { client, address } = useRecoilValue(walletState);
  const config = useConfig();

  const checkQueryClient = async () => {
    // while (true) {
    //   if (queryClient === undefined) {
    //     await sleep(sleepTime);
    //   } else {
    //     break;
    //   }
    // }
  }

  const checkTxnClient = async () => {
    // while (true) {
    //   if (client === undefined) {
    //     await sleep(sleepTime);
    //   } else {
    //     break;
    //   }
    // }
  }

  const checkAddressClient = async () => {
    // while (true) {
    //   if (address === undefined) {
    //     await sleep(sleepTime);
    //   } else {
    //     break;
    //   }
    // }
  }

  /*
   * Returns native token balance
   */
  const getBalance = async (tokenName: string) => {
    await checkQueryClient();
    await checkAddressClient();
    try {
      const balanceResponse = await (
        queryClient as SecretNetworkClient
      ).query.bank.balance({
        address: address as string,
        denom: config.getAsset(tokenName).native_denom as string,
      });

      return coinConvert(
        balanceResponse?.balance?.amount as string,
        6,
        "human"
      );
    } catch (error) {
      console.debug(error);
    }
  };

  /*
   * Transfers native token to given address
   */
  const doTransfer = async (
    tokenName: string,
    tokenAmount: string,
    destAddress: string,
    gasValue?: string | undefined,
  ) => {
    await checkTxnClient();
    try {
      const sendResponse = await (
        client as SecretNetworkClient
      ).tx.bank.send(
        {
          from_address: address as string,
          to_address: destAddress,
          amount: [
            {
              denom: config.getAsset(tokenName).native_denom as string,
              amount: coinConvert(tokenAmount, 6, "machine"),
            }
          ],
        },
        {
          gasLimit: parseInt((gasValue !== undefined)? gasValue: defaultGas.native_transfer),
        },
      );

      return sendResponse;
    } catch (error) {
      console.debug(error);
    }
  };

  return {
    getBalance,
    doTransfer,
  };
};
